import { Badge, Tab, Tooltip } from '@mui/material'

function commonProps(index) {
  return {
    id: `fpl-tab-${index}`,
    'aria-controls': `fpl-tabpanel-${index}`,
  }
}

interface IProps {
  tabDetails: { id: any; label: string }
  tooltipTitle: string
  tabProps: any
  disabled: boolean
  badgeCount?: number
}

const FplTab = (props: IProps) => {
  const { tabDetails, tooltipTitle, tabProps, disabled, badgeCount } = props

  return (
    <Tab
      {...tabProps}
      {...commonProps(tabDetails.id)}
      sx={{ pointerEvents: 'auto !important' }}
      value={tabDetails.id}
      disabled={disabled}
      label={
        <Tooltip
          title={tooltipTitle}
          disableHoverListener={!disabled}
          disableTouchListener={!disabled}
          disableFocusListener={!disabled}>
          <Badge
            color='primary'
            badgeContent={badgeCount}
            sx={{
              '& .MuiBadge-badge': {
                top: -5,
              },
            }}>
            <span>{tabDetails.label}</span>
          </Badge>
        </Tooltip>
      }
    />
  )
}

export default FplTab
